<div class="p-5">

  <!-- Header -->
  <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
    <div>
      <h1 class="text-2xl font-bold text-gray-800 flex items-center">
        <mat-icon class="text-aguacate-green mr-2">receipt_long</mat-icon>
        Registro Vita
        <span class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
          {{ total }} transacciones
        </span>
      </h1>
      <span class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mt-2">
        {{ total }} transacciones
      </span>
    </div>
    <button type="button" (click)="cargar()" [disabled]="loading"
      [style.opacity]="loading ? '0.5' : '1'" [style.cursor]="loading ? 'not-allowed' : 'pointer'"
      style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease; margin-top: 8px;"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">refresh</mat-icon>
      Actualizar
    </button>
  </div>

  <!-- Saldo USD de la bolsa -->
  <div class="mb-6" style="background:linear-gradient(135deg,#f0fdf4,#ecfdf5);border:1px solid #bbf7d0;border-radius:14px;padding:18px 22px;">
    <span style="font-size:0.72rem;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;color:#1e5a3f;">Saldo USD — bolsa de payouts</span>
    <div style="font-size:2rem;font-weight:800;color:#166534;line-height:1.1;margin-top:4px;">
      {{ saldoUsd | number:'1.2-2' }} <span style="font-size:0.95rem;color:#1e5a3f;">USD</span>
    </div>
  </div>

  <!-- Filtros -->
  <div class="flex justify-center mb-6">
    <div class="w-full max-w-4xl bg-white p-6 rounded-xl shadow-lg border border-gray-100">
      <div class="text-center mb-6">
        <h3 class="text-lg font-semibold text-gray-700 flex items-center justify-center">
          <mat-icon class="text-aguacate-green mr-2">filter_list</mat-icon>
          Filtros de Búsqueda
        </h3>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Buscar</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input matInput [(ngModel)]="filtroTexto" (ngModelChange)="aplicarFiltros()" placeholder="N°, remitente, email, beneficiario, Vita ID...">
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Estado</mat-label>
          <mat-select [(ngModel)]="filtroEstado" (ngModelChange)="aplicarFiltros()">
            <mat-option *ngFor="let e of estados" [value]="e.value">{{ e.label }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="flex justify-center py-6"><mat-spinner diameter="26"></mat-spinner></div>

  <div *ngIf="error && !loading" style="background:#fef2f2;border:1px solid #fecaca;border-radius:10px;padding:12px 16px;color:#dc2626;font-size:0.9rem;">
    {{ error }}
  </div>

  <ng-container *ngIf="!loading && !error">

    <!-- ═══ Tabla (solo desktop) ═══ -->
    <div class="hidden lg:block overflow-auto border rounded-lg shadow-md bg-white">
      <table mat-table [dataSource]="dataSource" class="w-full table-responsive">

        <ng-container matColumnDef="txId">
          <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">N° op</th>
          <td mat-cell *matCellDef="let t" class="text-center p-2 text-xs font-mono font-bold">#{{ t.txId }}</td>
        </ng-container>

        <ng-container matColumnDef="fecha">
          <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Fecha</th>
          <td mat-cell *matCellDef="let t" class="text-center p-2 text-xs">{{ t.fecha | date:'dd/MM/yy HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="ruta">
          <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Ruta</th>
          <td mat-cell *matCellDef="let t" class="text-center p-2 text-xs">
            <b style="color:#1e5a3f;">{{ t.origen.moneda }}</b> → <b style="color:#1e5a3f;">{{ t.destino.moneda || '—' }}</b>
            <div style="color:#9ca3af;font-size:0.68rem;">{{ t.origen.pais || '?' }} - {{ t.destino.pais || 'CO' }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="remitente">
          <th mat-header-cell *matHeaderCellDef class="text-left p-2 font-semibold">Usuario</th>
          <td mat-cell *matCellDef="let t" class="text-left p-2">
            <div class="font-medium text-sm">{{ t.remitente.nombre || '—' }}</div>
            <div class="text-xs font-bold font-mono">ID: {{ t.remitente.usuarioId }}</div>
            <div class="text-xs text-blue-600">{{ t.remitente.email }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="beneficiario">
          <th mat-header-cell *matHeaderCellDef class="text-left p-2 font-semibold">Beneficiario</th>
          <td mat-cell *matCellDef="let t" class="text-left p-2">
            <div class="font-medium text-xs">{{ t.beneficiarioDetalle?.nombre || t.beneficiario || '—' }}</div>
            <div class="text-xs text-blue-600 font-semibold">{{ t.beneficiarioDetalle?.cuentaMask || '' }}</div>
            <div class="text-xs" style="color:#6b7280;">{{ t.beneficiarioDetalle?.banco || '' }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="envia">
          <th mat-header-cell *matHeaderCellDef class="text-right p-2 font-semibold">Envía</th>
          <td mat-cell *matCellDef="let t" class="text-right p-2 text-xs font-bold text-green-600">
            {{ enviaMonto(t) | number:enviaFmt(t) }} {{ enviaMoneda(t) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="recibe">
          <th mat-header-cell *matHeaderCellDef class="text-right p-2 font-semibold">Recibe</th>
          <td mat-cell *matCellDef="let t" class="text-right p-2 text-xs font-bold text-green-600">{{ recibeDe(t) | number:fmtDe(t) }} {{ monedaDe(t) }}</td>
        </ng-container>

        <ng-container matColumnDef="tasa">
          <th mat-header-cell *matHeaderCellDef class="text-right p-2 font-semibold hide-on-mobile">Tasa</th>
          <td mat-cell *matCellDef="let t" class="text-right p-2 text-xs hide-on-mobile">
            {{ tasaValor(t) | number:tasaFmt(t) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="estado">
          <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Estado</th>
          <td mat-cell *matCellDef="let t" class="text-center p-2">
            <span class="px-2 py-0.5 inline-flex leading-5 font-bold rounded-full whitespace-nowrap"
              style="font-size: 0.65rem;" [style.background]="getStatusBg(t)" [style.color]="getStatusColor(t)">
              {{ estadoLabel(estadoDe(t)) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="acciones" stickyEnd>
          <th mat-header-cell *matHeaderCellDef class="text-center p-2 font-semibold">Detalle</th>
          <td mat-cell *matCellDef="let t" class="text-center p-2">
            <button title="Ver detalle" (click)="openDetalle(t)"
              style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border:1px solid #bfdbfe;border-radius:6px;background:#eff6ff;cursor:pointer;">
              <mat-icon style="font-size:16px;width:16px;height:16px;color:#2563eb;">visibility</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="hover:bg-gray-100 transition-colors"></tr>
      </table>
      <div *ngIf="total === 0" style="padding:18px;text-align:center;color:#9ca3af;">No se encontraron transacciones.</div>
      <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="20" showFirstLastButtons></mat-paginator>
    </div>

    <!-- ═══ Mobile / Tablet Cards (Acordeón) ═══ -->
    <div class="lg:hidden">
      <div *ngIf="total === 0" style="text-align:center;padding:40px 20px;">
        <mat-icon style="color:#d1d5db;font-size:48px;width:48px;height:48px;">receipt_long</mat-icon>
        <p style="color:#6b7280;font-size:0.9rem;margin-top:8px;">No se encontraron transacciones</p>
      </div>

      <div *ngFor="let t of dataSource.filteredData"
        style="border:1px solid #e5e7eb;border-radius:10px;overflow:hidden;margin-bottom:8px;"
        [style.border-color]="expandedCardId === t.txId ? '#1C593D' : '#e5e7eb'">

        <div (click)="toggleCard(t.txId)"
          style="display:flex;align-items:center;justify-content:space-between;padding:10px 14px;cursor:pointer;user-select:none;"
          [style.background]="expandedCardId === t.txId ? '#f0fdf4' : '#f9fafb'">
          <div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;flex:1;min-width:0;">
            <span style="background:#dcfce7;color:#1e5a3f;font-size:0.7rem;padding:2px 7px;border-radius:10px;font-weight:600;">#{{ t.txId }}</span>
            <span style="font-size:0.6rem;padding:2px 8px;border-radius:10px;font-weight:700;white-space:nowrap;"
              [style.background]="getStatusBg(t)" [style.color]="getStatusColor(t)">{{ estadoLabel(estadoDe(t)) }}</span>
            <span style="font-size:0.7rem;color:#374151;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ t.remitente.nombre || ('#'+t.remitente.usuarioId) }}</span>
            <span style="font-size:0.7rem;color:#1e5a3f;font-weight:700;white-space:nowrap;">{{ recibeDe(t) | number:fmtDe(t) }} {{ monedaDe(t) }}</span>
          </div>
          <mat-icon style="color:#6b7280;font-size:20px;width:20px;height:20px;transition:transform 0.2s ease;flex-shrink:0;margin-left:4px;"
            [style.transform]="expandedCardId === t.txId ? 'rotate(180deg)' : 'rotate(0)'">expand_more</mat-icon>
        </div>

        <div *ngIf="expandedCardId === t.txId" style="padding:12px 16px;background:white;">
          <div class="grid grid-cols-2 gap-x-8 gap-y-1">
            <div style="padding:4px 0;border-bottom:1px solid #f3f4f6;grid-column:1 / -1;">
              <span style="color:#6b7280;font-size:0.75rem;display:block;">Usuario</span>
              <span style="color:#111827;font-weight:500;font-size:0.85rem;">{{ t.remitente.nombre || '—' }}</span>
              <span style="color:#111827;font-weight:700;font-size:0.8rem;font-family:monospace;margin-left:6px;">ID: {{ t.remitente.usuarioId }}</span>
              <div style="color:#2563eb;font-size:0.8rem;word-break:break-all;">{{ t.remitente.email }}</div>
            </div>
            <div style="padding:4px 0;border-bottom:1px solid #f3f4f6;"><span style="color:#6b7280;font-size:0.75rem;display:block;">Ruta</span><span style="color:#111827;font-weight:500;font-size:0.85rem;">{{ t.origen.moneda }} → {{ t.destino.moneda || '—' }}</span></div>
            <div style="padding:4px 0;border-bottom:1px solid #f3f4f6;"><span style="color:#6b7280;font-size:0.75rem;display:block;">Fecha</span><span style="color:#111827;font-weight:500;font-size:0.8rem;">{{ t.fecha | date:'dd/MM/yy HH:mm' }}</span></div>
            <div style="padding:4px 0;border-bottom:1px solid #f3f4f6;"><span style="color:#6b7280;font-size:0.75rem;display:block;">Envía</span><span style="color:#1e5a3f;font-weight:700;font-size:0.9rem;">
              {{ enviaMonto(t) | number:enviaFmt(t) }} {{ enviaMoneda(t) }}
            </span></div>
            <div style="padding:4px 0;border-bottom:1px solid #f3f4f6;"><span style="color:#6b7280;font-size:0.75rem;display:block;">Recibe</span><span style="color:#1e5a3f;font-weight:700;font-size:0.9rem;">{{ recibeDe(t) | number:fmtDe(t) }} {{ monedaDe(t) }}</span></div>
            <div style="padding:4px 0;border-bottom:1px solid #f3f4f6;grid-column:1 / -1;"><span style="color:#6b7280;font-size:0.75rem;display:block;">Beneficiario</span><span style="color:#111827;font-weight:500;font-size:0.85rem;">{{ t.beneficiarioDetalle?.nombre || t.beneficiario || '—' }}<span *ngIf="t.beneficiarioDetalle?.cuentaMask" style="color:#2563eb;font-weight:600;"> | {{ t.beneficiarioDetalle?.cuentaMask }}</span></span></div>
          </div>
          <div style="display:flex;gap:8px;padding-top:10px;">
            <button (click)="openDetalle(t)"
              style="display:flex;align-items:center;gap:6px;padding:8px 14px;background:#2563eb;color:white;border:none;border-radius:8px;font-size:0.8rem;font-weight:600;cursor:pointer;flex:1;justify-content:center;">
              <mat-icon style="font-size:16px;width:16px;height:16px;">visibility</mat-icon>
              Ver detalle (interno)
            </button>
          </div>
        </div>
      </div>
    </div>

  </ng-container>
</div>
